module.exports = __webpack_public_path__ + "img/yunfenxiang.ed323380.png";